/* eslint-disable import/no-cycle */
import { Box, HStack, Icon, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdInfoOutline } from 'react-icons/md';
import { SCREENING_TYPE } from '../../../questionnaireTemplate.enums';
import { QuestionnaireBuilderElementProps } from '../../../questionnaireTemplate.types';
import { QuestionRequireResponse } from '../formElements/QuestionRequireResponse';
import { QuestionSkipQuestion } from '../formElements/QuestionSkipQuestion';
import { ScreeningType } from '../formElements/ScreeningType';
import { VideoResponseDurationSelect } from '../formElements/VideoResponseDurationSelect';

const FILE_TYPE_CONTAINER_PROPS = {
  px: 3,
  py: 1,
  borderRadius: 'md',
  border: '1px solid #AED0FF',
  bg: '#EFF6FF',
} as const;

export const VideoResponse = React.memo(function VideoResponse({ elementId }: QuestionnaireBuilderElementProps) {
  const { t } = useTranslation('questionnaireTemplate');

  return (
    <>
      <Box {...FILE_TYPE_CONTAINER_PROPS}>
        <HStack spacing={2}>
          <Icon as={MdInfoOutline} color="#1F3CBA" boxSize={4} />
          <Text data-testid="validation-rules-title" fontSize="sm" color="#2339A0">
            {t('formBuilder.canvas.element.validationRules.title')}
          </Text>
        </HStack>
        <HStack spacing={2} lineHeight="2.5rem">
          <Text data-testid="max-video-length-label" fontSize="sm" color="gray.700">
            {t('formBuilder.canvas.element.validationRules.videoResponse.maxVideoLength')}
          </Text>
          <VideoResponseDurationSelect elementId={elementId} />
          <Text data-testid="min-label" fontSize="sm" color="gray.700">
            {t('formBuilder.canvas.element.validationRules.videoResponse.minLabel')}
          </Text>
        </HStack>
      </Box>
      <ScreeningType id={elementId} screeningTypes={[SCREENING_TYPE.NONE, SCREENING_TYPE.REVIEW]} />
      <HStack spacing={4}>
        <QuestionRequireResponse elementId={elementId} />
        <QuestionSkipQuestion elementId={elementId} />
      </HStack>
    </>
  );
});
